import { render, staticRenderFns } from "./GvDetails.vue?vue&type=template&id=19f944e0&scoped=true"
import script from "./GvDetails.vue?vue&type=script&lang=js"
export * from "./GvDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f944e0",
  null
  
)

export default component.exports